import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/**
 * Punto de entrada principal (Entry Point) para el arranque de la aplicación Angular.
 * * Este proceso inicializa el entorno de ejecución del framework y monta el componente raíz `App`
 * en el DOM (normalmente en la etiqueta `<app-root>`). Al utilizar `bootstrapApplication`,
 * la aplicación prescinde de los tradicionales `NgModules` en favor de la arquitectura
 * de componentes independientes (Standalone).
 * * La configuración global (rutas, interceptores, proveedores de servicios) se inyecta
 * a través del objeto `appConfig`.
 * * @throws Captura y muestra en la consola cualquier error fatal ocurrido durante la fase
 * de inicialización que impida el arranque del sistema.
 */
registerLocaleData(localeEs);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
